import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import styles from './CostCalculator.module.scss'
import { Row, Container, Col, Button, Form, Image } from 'react-bootstrap'
import { CustomTextField } from '../shared/customTextField'
import { CustomButton } from '../shared/customButton'
import { CustomAlertBox } from '../shared/customAlertBox'
import { Formik } from 'formik';
import * as yup from 'yup';
import { Link } from 'react-router-dom';
import { Tooltip as ReactTooltip } from 'react-tooltip'




const CostCalculator = () => {

    let [step, setStep] = useState(1);

    let [inputData, SetinputData] = useState();

    //states for set number of candidates
    let [CandidateNo, SetCandidateNo] = useState(0);
    let [Candidate200, SetCandidate200] = useState(0);
    let [Candidate1000, SetCandidate1000] = useState(0);
    let [Candidate1200, SetCandidate1200] = useState(0);

    //states to set cost of candidates
    let [totalCandidateCost, setTotalCandidateCost] = useState(0);
    let [candidateCost200, setCandidateCost200] = useState(0);
    let [candidateCost1000, setCandidateCost1000] = useState(0);
    let [candidateCost1200, setCandidateCost1200] = useState(0);

    //states to set cost for video interview
    let [noOfInterviewers, setNoOfInterviewers] = useState(0);
    let [interviewMinutes, setInterviewMinutes] = useState(0);
    let [interviewsPerMonth, setInterviewPerMonth] = useState(0);
    let [attendeePerInterview, setAttendeePerInterview] = useState(0);
    let [attendeeMinutes, setAttendeeMinutes] = useState(0);
    let [perInterviewCost, setPerInterviewCost] = useState(0);
    let [TotalInterviewCost, setTotalInterviewCost] = useState(0);

    //state to set total monthly cost
    let [totalMonthlyCost, setTotalMonthlyCost] = useState(0);

    //const for per candidate fee
    const cost_per_candidate_first_200 = 0.4;
    const cost_per_candidate_next_1000 = 0.3;
    const cost_per_candidate_above_1200 = 0.2;

    //const for per video interview minute
    const cost_per_interview_minute = 0.003;

    //function to navigate to pricing page
    const handleNavigation = () => {
        window.location.href = 'https://hiretrace.io/pricing';
    };

    const onSubmit = async (values) => {
        // Set input data and other values synchronously
        SetinputData(values);
        SetCandidateNo(values.candidateNo);
        calcCandidates(values.candidateNo);
        setInterviewPerMonth(values.interviewsPerMonth);
    
        const interviewMinutes = 20;
        const interviewerNo = 2;
        CalcInterviewCost(interviewerNo, interviewMinutes, values.interviewsPerMonth);
    
        TotalMonthlyCost();
        setStep(2);
    }
    

    //calcualte total candidates cost
    const calcCandidates = (values) => {
        if (values <= 200) {
            SetCandidate200(values);
            let total = cost_per_candidate_first_200 * values;
            //const noZeroes = parseFloat(total.toFixed(3))

            setCandidateCost200(parseFloat(total.toFixed(2)));
            setTotalCandidateCost(parseFloat(total.toFixed(2)));
        }
        else if (values <= 1200) {
            SetCandidate200(200)
            let candidates = values - 200;
            SetCandidate1000(candidates);
            let total200 = (200 * cost_per_candidate_first_200);
            let total1000 = (candidates * cost_per_candidate_next_1000);
            setCandidateCost200(total200);
            setCandidateCost1000(total1000);
            let total = (200 * cost_per_candidate_first_200) + (candidates * cost_per_candidate_next_1000);
            setTotalCandidateCost(parseFloat(total.toFixed(2)));

        }
        else {
            SetCandidate200(200);
            SetCandidate1000(1000);
            let candidates = values - 1200;
            SetCandidate1200(candidates);
            let total200 = (200 * cost_per_candidate_first_200);
            let total1000 = (1000 * cost_per_candidate_next_1000);
            let total1200 = (candidates * cost_per_candidate_above_1200)
            setCandidateCost200(total200);
            setCandidateCost1000(total1000);
            setCandidateCost1200(parseFloat(total1200.toFixed(2)));
            let total = (200 * cost_per_candidate_first_200) + (1000 * cost_per_candidate_next_1000) + (candidates * cost_per_candidate_above_1200);
            setTotalCandidateCost(parseFloat(total.toFixed(2)));
        }

    }

    //calculate total interview cost
    const CalcInterviewCost = (interviewers, minutes, interviewPerMonths) => {
        setInterviewMinutes(minutes);
        setNoOfInterviewers(interviewers);
        let totalAttendees = parseInt(interviewers) + 1;
        let attendeeMinPerInterview = totalAttendees * minutes;
        let perInterviewCost = attendeeMinPerInterview * cost_per_interview_minute;
        let totalInterviewCost = perInterviewCost.toFixed(2) * interviewPerMonths;
        setAttendeePerInterview(totalAttendees);
        setAttendeeMinutes(attendeeMinPerInterview);
        setPerInterviewCost(parseFloat(perInterviewCost.toFixed(2)));
        setTotalInterviewCost(parseFloat(totalInterviewCost.toFixed(2)))

    }

    //calculate total cost
    const TotalMonthlyCost = () => {
        let TotalMonthlyCost = totalCandidateCost + TotalInterviewCost;
        calcTotal(parseFloat(TotalMonthlyCost.toFixed(2)));
    }

    const calcTotal = (total) => {
        setTotalMonthlyCost(total);
    }

    const schema = yup.object().shape({
        candidateNo: yup.number().typeError('Only numbers allowed').required('Required').integer().moreThan(-1),
        interviewsPerMonth: yup.number().typeError('Only numbers allowed').required('Required').integer('Invalid input').moreThan(-1, 'Invalid input'),
    })

    useEffect(() => {
        TotalMonthlyCost();
    }, [totalMonthlyCost, totalCandidateCost, TotalInterviewCost])



    const GetDetails = () => {
        return (
            <>

                <Formik
                    validationSchema={schema}
                    initialValues={{
                        candidateNo: 250,
                        interviewsPerMonth: 25,

                    }}
                    onSubmit={(values) => { onSubmit(values) }}

                >
                    {({
                        values,
                        handleSubmit,
                        handleChange,
                        submitCount,
                        errors,

                    }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <div className={styles.inputBox}>
                            <p className={styles.inputFildHeader}>Cost for New Candidates </p>
                            <p className={styles.inputFildSubHeader}>Roughly how many new candidates apply for your company per month?</p>
                            <CustomTextField
                                        name="candidateNo"
                                        classLabel="defaultLabel"
                                        controlId="candidateNo"
                                        placeholder="250"
                                        type="text"
                                        disabled={false}
                                        value={values.candidateNo}
                                        classType="defaultTextBox"
                                        handleOnChange={handleChange}
                                        errorMessage={errors.candidateNo}
                                        isInvalid={submitCount > 0 && !!errors.candidateNo}
                                    />
                            
                            </div>
                            <div className={styles.inputBox}>
                            <p className={styles.inputFildHeader}>Cost for Online Interviews</p>
                            <p className={styles.inputFildSubHeader}>How many video interviews you have per month ?</p>
                            <CustomTextField
                                        //label="Stage Name"
                                        name="interviewsPerMonth"
                                        classLabel="defaultLabel"
                                        controlId="interviewsPerMonth"
                                        placeholder="Interviews per month"
                                        type="text"
                                        disabled={false}
                                        value={values.interviewsPerMonth}
                                        classType="defaultTextBox"
                                        handleOnChange={handleChange}
                                        errorMessage={errors.interviewsPerMonth}
                                        isInvalid={submitCount > 0 && !!errors.interviewsPerMonth}
                                    />
                            
                            </div>
                           

                            <Row className={styles.actionBtns}>
                                <Col className="mt-3 ps-0">

                                    <CustomButton
                                        buttonType="button"
                                        label="Back to Pricing Page"
                                        type="defaultBtn"
                                        handleClick={handleNavigation}
                                    />

                                </Col>
                                <Col className="mt-3 pe-0 me-0">

                                    <CustomButton
                                        buttonType="submit"
                                        label="Calculate Estimate"
                                        type="primaryBtn"
                                    />
                                </Col>
                            </Row>



                        </Form>

                    )}

                </Formik>

            </>
        )
    }

    const Calculation = () => {
        
        let[showCandidateCostExplantion, setShowCandidateCostExplantion]= useState(false);
        let[showInterviewCostExplantion, setShowInterviewCostExplantion]= useState(false);


        return (
            <>
               
                <Row className=''>
                    <Col className={styles.rowData}>
                    <Row className='mt-3'>
                    <Col >
                        <p className={styles.stepSubtopicName}>
                            Candidate Cost Calculation
                        </p>
                    </Col>
                </Row>
                    <div className={showCandidateCostExplantion? styles.showExplantion : styles.hideExplantion }>
                        <Row >
                            <Col sm={3} md={6} lg={5} xl={7} >
                                <Row className={styles.rowItem} >
                                    <p className={styles.subTopicLabels} >Cost for first 200 candidates</p>
                                </Row>
                            </Col>
                            <Col sm={1} lg={3} >
                                <p className={styles.subTopicValues}>{Candidate200} x  $ {cost_per_candidate_first_200}</p>
                            </Col>
                            <Col sm={1} lg={2}>
                                <p className={styles.subTopicValues}>$ {candidateCost200}</p>
                            </Col>

                        </Row>
                        <Row >
                            <Col>
                            <Row className={styles.rowItem} >
                                    <p className={styles.subTopicLabels} >Cost for Next  1000 candidates </p>
                                </Row>
                            </Col>
                            <Col lg={3}>
                                <p className={styles.subTopicValues}>{Candidate1000} x $ {cost_per_candidate_next_1000} </p>
                            </Col>
                            <Col lg={2}>
                                <p className={styles.subTopicValues}>$ {candidateCost1000}</p>
                            </Col>

                        </Row>
                        <Row >
                            <Col>
                            <Row className={styles.rowItem} >
                                    <p className={styles.subTopicLabels} >Cost for above 1200 candidates </p>
                                    
                                </Row>
                            </Col>
                            <Col lg={3}>
                                <p className={styles.subTopicValues}>{Candidate1200} x $ {cost_per_candidate_above_1200}</p>
                            </Col>
                            <Col lg={2}>
                                <p className={styles.subTopicValues}>$ {candidateCost1200}</p>
                            </Col>

                        </Row>
                        </div>
                        <Row className='mt-3'>
                            <Col lg={4} >
                                <p className={styles.TopicLabelHighlight}>Cost for {CandidateNo} Candidates</p>
                            </Col>
                            <Col lg={6}>
                                <div className={styles.togelBtn} onClick={() => setShowCandidateCostExplantion(!showCandidateCostExplantion)}>
                                    <p>{showCandidateCostExplantion ? 'Hide explanation': 'Show explanation'}</p>
                                    <svg className={`${styles.rotate} ${!showCandidateCostExplantion ? styles.rotate180 : ''}`} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18 15L12 9L6 15" stroke="#98A2B3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                            </Col>
                            <Col lg={2}>
                                <p className={styles.TopicValueHighlighted}>$ {totalCandidateCost}</p>
                            </Col>

                        </Row>


                        <Row >
                            <Col >
                                <p className={styles.stepSubtopicName2}>
                                    Video Interview  Cost Calculation
                                </p>
                            </Col>
                        </Row>
                        <div className={showInterviewCostExplantion? styles.showExplantion : styles.hideExplantion }>
                        <Row>
                            <Col className='mb-2'>
                                <CustomAlertBox
                                    alertBodyText="Assume 3 attendees per interview (two interviewers and the candidate) and interview duration is 20 mins."
                                    alertType="defaultAlert"
                                />
                            </Col>
                        </Row>
                        <Row >
                            <Col>
                            <Row className={styles.rowItem} >
                                    <p className={styles.subTopicLabels} >Attendee minutes per interview</p>
                                </Row>
                            </Col>
                            <Col lg={3} >
                                <p className={styles.subTopicValues}>{interviewMinutes} mins  x {attendeePerInterview}</p>
                            </Col>
                            <Col lg={2}>
                                <p className={styles.subTopicValues}> {attendeeMinutes} mins</p>
                            </Col>

                        </Row>
                        <Row >
                            <Col>
                            <Row className={styles.rowItem} >
                                    <p className={styles.subTopicLabels} >Cost for one interview</p>
                                </Row>
                            </Col>
                            <Col lg={3} >
                            <p className={styles.subTopicValues}>{attendeeMinutes} mins  x $ {cost_per_interview_minute}</p>
                            </Col>
                            <Col lg={2}>
                                <p className={styles.subTopicValues}>$ {perInterviewCost}</p>
                            </Col>

                        </Row>
                        <Row >
                            <Col>
                            <Row className={styles.rowItem} >
                                    <p className={styles.subTopicLabels} >Interviews per month</p>
                                </Row>
                            </Col>
                            <Col lg={3} >
                                
                            </Col>
                            <Col lg={2}>
                                <p className={styles.subTopicValues}>{interviewsPerMonth}</p>
                            </Col>

                        </Row>
                        </div>
                        <Row className='pl-3'>
                            <Col lg={4} >
                                <Row className={styles.rowItem}>
                                    <p className={styles.TopicLabelHighlight}>Cost for {interviewsPerMonth} interviews</p>
                                </Row>
                            </Col>
                            <Col lg={6}>
                                <div className={styles.togelBtn} onClick={() => setShowInterviewCostExplantion(!showInterviewCostExplantion)}>
                                    <p>{showInterviewCostExplantion? 'Hide explanation': 'Show explanation'}</p>
                                    <svg className={`${styles.rotate} ${!showInterviewCostExplantion ? styles.rotate180 : ''}`} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18 15L12 9L6 15" stroke="#98A2B3" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                            </Col>
                            <Col lg={2}>
                                <p className={styles.TopicValueHighlighted}>$ {TotalInterviewCost}</p>
                            </Col>

                        </Row>
                        <Row className={styles.totalRow}>
                            <Col sm={5} md={6} lg={8} >
                                <Row className={styles.totalLabelRow}>
                                    <p className={styles.TotalLabel}>
                                        Total Monthly Cost
                                    </p>
                                </Row>
                            </Col>
                            <Col lg={2}>
                            </Col>
                            <Col lg={2}>
                            <p className={styles.TotalValue}>
                                    $ {totalMonthlyCost}
                                </p>
                            </Col>

                        </Row>
                    </Col>
                </Row >
                <Row className={styles.actionBtns}>
                            <Col className="pl-0">
                                <CustomButton
                                    buttonType="button"
                                    label="Calculate Again"
                                    type="defaultBtn"
                                    handleClick={() => setStep(1)}

                                />
                            </Col>
                            <Col className="pr-0">
                                <Link to="/signup" className={styles.startBtn}>
                                    <CustomButton
                                        buttonType="submit"
                                        label="Start Free Trial"
                                        type="primaryBtn"
                                    />
                                </Link>
                            </Col>
                        </Row>
            </>
        )
    }




    return (
        <div>
            <Helmet>
                <title>Cost Calculator | HireTrace</title>
            </Helmet>
            <Row className={styles.loginBackgroundColor}>
                <Container className='justify-content-center'>
                    <Row className='justify-content-center'>
                       <Col md={5} >
                            <div className={styles.loginBox}>
                                <Container className={styles.innerBoxContainer}>

                                    <Col sm={{ span: 8, offset: 2 }} className={styles.companyLogoDiv}>
                                        <div className={styles.companySecondLogoDiv}>
                                            <a href="/" target="_blank" rel="noreferrer">
                                                <Image src={`${process.env.REACT_APP_FRONTEND_BASE_URL}/images/favicon (1).ico`} rounded fluid className={styles.companyLogo} />
                                            </a>
                                        </div>
                                        <div className={styles.LogoText}>HireTrace</div>
                                    </Col>

                                    <div className={styles.modalHeaderDiv}>
                                        <h2 className={styles.modalHeader}>Calculate your Estimated Monthly Bill</h2>
                                    </div>
                                    <div className={styles.stepPosition}>
                                    <Col xs={3} >
                                        <div className={step === 1 ? `${styles.roundStepMainDiv}` : step === 2 ? `${styles.roundStepMainDiv} ${styles.roundStepMainDiv2}` : `${styles.roundStepMainDiv}`}>
                                            <div className={styles.stepActive}>
                                                {
                                                    step === 1 ?
                                                        <svg className={styles.svgRound} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g id="Content">
                                                                <rect width="24" height="24" rx="12" fill="#ECFAFD" />
                                                                <circle id="Dot" cx="12" cy="12" r="4" fill="#2DA6C0" />
                                                            </g>
                                                        </svg>
                                                        :
                                                        <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g clip-path="url(#clip0_613_29628)">
                                                                <rect y="0.5" width="24" height="24" rx="12" fill="#ECFAFD" />
                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0965 7.89004L9.9365 14.8L8.0365 12.77C7.6865 12.44 7.1365 12.42 6.7365 12.7C6.3465 12.99 6.2365 13.5 6.4765 13.91L8.7265 17.57C8.9465 17.91 9.3265 18.12 9.7565 18.12C10.1665 18.12 10.5565 17.91 10.7765 17.57C11.1365 17.1 18.0065 8.91004 18.0065 8.91004C18.9065 7.99004 17.8165 7.18004 17.0965 7.88004V7.89004Z" fill="#2DA6C0" />
                                                            </g>
                                                            <defs>
                                                                <clipPath id="clip0_613_29628">
                                                                    <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                                </clipPath>
                                                            </defs>
                                                        </svg>
                                                }

                                            </div>
                                            <div className={(step === 2) ? styles.stepActive : ''}>
                                                {
                                                    step === 2 ?
                                                        <svg className={styles.svgRound} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <g id="Content">
                                                                <rect width="24" height="24" rx="12" fill="#ECFAFD" />
                                                                <circle id="Dot" cx="12" cy="12" r="4" fill="#2DA6C0" />
                                                            </g>
                                                        </svg>
                                                        :
                                                        (step === 2) ?
                                                            <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <g clip-path="url(#clip0_613_29628)">
                                                                    <rect y="0.5" width="24" height="24" rx="12" fill="#ECFAFD" />
                                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0965 7.89004L9.9365 14.8L8.0365 12.77C7.6865 12.44 7.1365 12.42 6.7365 12.7C6.3465 12.99 6.2365 13.5 6.4765 13.91L8.7265 17.57C8.9465 17.91 9.3265 18.12 9.7565 18.12C10.1665 18.12 10.5565 17.91 10.7765 17.57C11.1365 17.1 18.0065 8.91004 18.0065 8.91004C18.9065 7.99004 17.8165 7.18004 17.0965 7.88004V7.89004Z" fill="#2DA6C0" />
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="clip0_613_29628">
                                                                        <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                                    </clipPath>
                                                                </defs>
                                                            </svg>
                                                            :
                                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <g clip-path="url(#clip0_613_29582)">
                                                                    <rect width="24" height="24" rx="12" fill="#F9FAFB" />
                                                                    <circle cx="12" cy="12" r="4" fill="#D0D5DD" />
                                                                </g>
                                                                <defs>
                                                                    <clipPath id="clip0_613_29582">
                                                                        <rect width="24" height="24" rx="12" fill="white" />
                                                                    </clipPath>
                                                                </defs>
                                                            </svg>
                                                }
                                            </div>
                                        </div>
                                    </Col>
                                    </div>


                                    <Col sm={12}>
                                        <Container>
                                            {
                                                step == 1 ? (
                                                    <>
                                                        <GetDetails />
                                                    </>
                                                )
                                                    : null
                                            }
                                            {
                                                step == 2 ? (
                                                    <>
                                                        <Calculation />
                                                    </>
                                                )
                                                    : null
                                            }
                                            {/* Rendering Content Goes Here
                                            {step === 1  && <StageDetailsConfiguration nextPage={nextPage} setSubmitValues={setSubmitValues} values={values} />}
                                            {step === 2  && <Review nextPage={nextPage} previousPage={previousPage} values={values} handleClose={props.handleClose} refreshData={props.refreshData} GetTaskValues={props.GetTaskValues} />} */}
                                        </Container>
                                    </Col>

                                </Container>
                            </div>
                        </Col>

                    </Row>

                </Container>
            </Row>


        </div>
    )
}

export default CostCalculator
